export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Debug"] = 0] = "Debug";
    LogLevel[LogLevel["Info"] = 1] = "Info";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Error"] = 3] = "Error";
})(LogLevel || (LogLevel = {}));
export default class Logger {
    static debug(...args) {
        this.log(LogLevel.Debug, ...args);
    }
    static info(...args) {
        this.log(LogLevel.Info, ...args);
    }
    static warn(...args) {
        this.log(LogLevel.Warn, ...args);
    }
    static error(...args) {
        this.log(LogLevel.Error, ...args);
    }
    static log(level, ...args) {
        if (this.logLevel > level) {
            return;
        }
        switch (level) {
            case LogLevel.Debug: {
                console.debug(...args);
                break;
            }
            case LogLevel.Info: {
                console.info(...args);
                break;
            }
            case LogLevel.Warn: {
                console.warn(...args);
                break;
            }
            case LogLevel.Error: {
                console.error(...args);
                break;
            }
        }
    }
}
Logger.logLevel = LogLevel.Info;
//# sourceMappingURL=Logger.js.map